/** @type {import('./global')} */
import React, { createContext, useState } from "react";

/**
 * @type {React.Context<BudgetType>}
 */
/**
 * @typedef Tagging_ContextType
 * @property {string[]} SelectedTagID
 * @property {React.Dispatch<React.SetStateAction<string>>} setSelectedTagID
 * @property {string[]} isLayoverOpen
 * @property {React.Dispatch<React.SetStateAction<string>>} setIsLayoverOpen
 * @property {string[]} Editdata
 * @property {React.Dispatch<React.SetStateAction<string>>} setEditdata
 * @property {React.Dispatch<React.SetStateAction<string>>} refetchTable
 * @property {React.Dispatch<React.SetStateAction<string>>} setRefetchTable
 * @property {string[]} confirmationmodal
 * @property {React.Dispatch<React.SetStateAction<string>>} setConfirmationmodal
 * @property {string[]} DeleteData
 * @property {React.Dispatch<React.SetStateAction<string>>} setDeleteData
 * @property {string[]} selectTagKeys
 * @property {React.Dispatch<React.SetStateAction<string>>} setSelectTagKeys
 */

export const TaggingContext = createContext();

/**
 * @returns {Tagging_ContextType}
 */
export const useTaggingContext = () => {
  const [SelectedTagID, setSelectedTagID] = useState("");
  const [isLayoverOpen, setIsLayoverOpen] = useState(false);
  const [Editdata, setEditdata] = useState();
  const [refetchTable, setRefetchTable] = useState(() => () => {});
  const [confirmationmodal, setConfirmationmodal] = useState(false);
  const [DeleteData, setDeleteData] = useState();
  const [selectTagKeys, setSelectTagKeys] = useState([]);
  return {
    Editdata,
    setEditdata,
    isLayoverOpen,
    setIsLayoverOpen,
    SelectedTagID,
    setSelectedTagID,
    confirmationmodal,
    setConfirmationmodal,
    selectTagKeys,
    setSelectTagKeys,
    DeleteData,
    setDeleteData,
    refetchTable,
    setRefetchTable,
  };
};

export const TaggingProvider = ({ children }) => {
  const context = useTaggingContext();

  return (
    <>
      <TaggingContext.Provider value={context}>
        {children}
      </TaggingContext.Provider>
    </>
  );
};
